import { Board } from "./Board";
import { GUI } from "./GUI";
import { HUD } from "./hud/HUD";
import { PauseLayer } from "./PauseLayer";
import { PawnPromotionLayer } from "./PawnPromotionLayer";
import { StartLayer } from "./start-layer/StartLayer";
import { EndGameLayer } from "./EndGameLayer";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { BoardManagerAI } from "./BoardManagerAI";
import { AudioManager } from "../AudioManager";

export class BoardState extends Phaser.State {

    public static currentInstance: BoardState = null;

    public board: Board;
    public gui: GUI;
    public hud: HUD;
    public pauseLayer: PauseLayer;

    private pawnPromotionLayer: PawnPromotionLayer;
    private startLayer: StartLayer;
    private endGameLayer: EndGameLayer;
    
    public init(): void {

        BoardState.currentInstance = this;

        this.hud = null;
        this.gui = null;
        this.endGameLayer = null;
        this.pauseLayer = null;
    }

    public create(): void {

        const backgroundImage = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "texture_atlas_1", "bg.png");
        backgroundImage.scale.set(2, 2 * GameVars.scaleY);
        backgroundImage.anchor.set(.5);
        
        this.gui = new GUI(this.game);
        this.add.existing(this.gui);

        if (GameVars.againstAI) {
            BoardManagerAI.init(this.game);
        }
        
        if (AudioManager.loopPlayingKey === null) {
            AudioManager.playSound("loop", true);
        }
        
        this.game.camera.flash(0x000000, GameConstants.TIME_FADE, false);
    }

    public shutdown(): void {

        BoardState.currentInstance = null;

        if (GameVars.againstAI) {
            BoardManagerAI.shutdown();
        }

        super.shutdown();
    }

    public setBoard(showStartLayer?: boolean): void {

        this.board = new Board(this.game);
        this.add.existing(this.board);

        this.hud = new HUD(this.game);
        this.add.existing(this.hud);

        if (showStartLayer) {
            this.startLayer = new StartLayer(this.game);
            this.add.existing(this.startLayer);
        } else {
            this.startLayer = null;
        }
    }

    public startGame(): void {

        if (this.startLayer) {
            this.startLayer.destroy();
        }

        this.hud.startGame();
    }

    public playerColorSet(): void {

        this.board.setColorPlayer(GameVars.colorPlayer);
    }

    public stalemate(): void { 

        if (this.hud) {
            this.hud.endGame();
        }

        this.endGameLayer = new EndGameLayer(this.game);
        this.add.existing(this.endGameLayer);

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_POKI) {
            PokiSDK.gameplayStop();
        }
    }

    public checkmate(): void {

        if (this.hud) {
            this.hud.endGame();
        }

        if (this.pauseLayer) {
            this.pauseLayer.destroy();
        }

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_POKI) {
            PokiSDK.happyTime(1);

            PokiSDK.gameplayStop();
        }
        
        this.endGameLayer = new EndGameLayer(this.game);
        this.add.existing(this.endGameLayer);
    }

    public showFinishedGameData(): void {
        
        if (this.endGameLayer) {
            this.endGameLayer.showFinishedGameData();
        }
    }

    public check(uploadedGame?: boolean): void {
        
        this.board.check(uploadedGame);
    }

    public uncheck(): void {
        
        this.board.uncheck();
    }

    public showPawnPromotionMenu(): void {

        // mostrar el menu
        this.pawnPromotionLayer = new PawnPromotionLayer(this.game);
        this.add.existing(this.pawnPromotionLayer);
    }

    public removePawnPromotionLayer(): void {

            this.pawnPromotionLayer.destroy();
    }

    public resign(): void {

        this.game.state.restart(true, false);
    }

    public showPauseLayer(): void {

        this.pauseLayer = new PauseLayer(this.game);
        this.add.existing(this.pauseLayer);
    }

    public hidePauseLayer(): void {

        this.pauseLayer.destroy();
        this.pauseLayer = null;

        this.gui.pauseLayerHidden();
    }

    public showPreWaitingLayer(): void {
        //
    }

    public revertLastMovement(move: Move): void {
        
        this.board.revertLastMovement(move);
    }
}
